
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import MqttMixIn from '../mixins/mqttManagement';
export interface MqttTopicStatus {
  topic: string;
  connected: boolean;
  timerId?: ReturnType<typeof setTimeout>;
}

/**
 * Subscribes to and monitors connected status of all mqtt topics passed in.
 * Results are displayed in an expansion panel.
 */
@Component({})
export default class extends Mixins(MqttMixIn) {
  @Prop({ default: [] }) topics!: string[];
  @Prop({ default: false }) reset!: boolean;
  @Prop({ required: true }) PubSub: any;

  statuses: MqttTopicStatus[] = [];
  heartBeatTimeout = 2000; // Twice the expected message rate

  mounted() {
    this.initializeAllTopics();
    this.subscribeToTopics();
  }

  destroyed() {
    this.clearTimerIds();
    this.removeMqttVisibility();
  }

  @Watch('reset')
  onReset() {
    this.clearTimerIds();
    this.resetConnection();
  }

  /**
   * Initialize all topics to false so they show up in the subscription list
   */
  initializeAllTopics() {
    this.topics.forEach((topic) => {
      this.statuses.push({ topic: topic, connected: false });
    });
  }

  /**
   * Subscribe to all topics.
   */
  async subscribeToTopics() {
    this.statuses.forEach((status) => {
      this.topicSubscription(status.topic, status.timerId);
    });

    this.actions.forEach((act, key) => {
      this.subscriptions.set(key, act());
    });
  }

  /**
   * Subscribe to and monitor topic subscription statuses.
   * Clear and restart the Timeout (which sets subscription status to false) if another message is
   * received within the interval of heartBeatTimeout.
   * @param topic
   * @param timerId
   */
  topicSubscription(topic: string, timerId?: ReturnType<typeof setTimeout>) {
    this.addMqttVisibility(topic, () =>
      this.PubSub.subscribe(topic).subscribe({
        next: (data: any) => {
          if (timerId) clearInterval(timerId);
          this.updateTopic(topic, true);
          timerId = setTimeout(() => this.updateTopic(topic, false), this.heartBeatTimeout);
        },
        error: (error: any) => console.log(error)
      })
    );
  }

  /**
   * Update connected status of topic.
   * @param topic
   * @param connected
   */
  updateTopic(topic: string, connected: boolean) {
    const index = this.statuses.findIndex((status) => status.topic == topic);
    if (index >= 0) {
      this.statuses[index].connected = connected;
    }
  }

  /**
   * Clear the status timers.
   */
  clearTimerIds() {
    this.statuses.forEach((status) => {
      if (status.timerId) clearInterval(status.timerId);
    });
  }
}
